export const UserReducer = (state = null) => {
    return state;
}